import React from 'react'
import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'

export const useAccountPropertiesMutation = () => {
  return useGenericRequestHandler({
    route: 'v1/i/updateProperties',
    method: 'POST'
  })
}
